import Level from '../../lib/models/Level';

export default {
    name: 'LevelsMixin',

    data() {
        return {
            levels_loaded: false,
            allow_refresh: false,
            refreshing_levels: false,
        };
    },

    computed: {
        levels() {
            return Level.all();
        },

        active_model_levels() {
            if (this.modelObject && this.levels_loaded) {
                const levels = this.modelObject.levels.map(level => level.level_id);

                return Level.query().whereIdIn(levels).get();
            }

            return [];
        },
    },

    methods: {
        fetchLevels(force_load = false) {
            if (!this.$store.state.db.levels.all_data_loaded || force_load) {
                Level.api().fetch().then(() => {
                    this.levels_loaded = true;
                    this.$store.commit('db/levels/setDataLoaded');

                    this.refreshing_levels = false;
                });
            } else {
                this.levels_loaded = true;
            }
        },

        refreshLevels() {
            this.refreshing_levels = true;
            this.allow_refresh = false;
            this.fetchLevels(true);
        },

        openLevelsPage() {
            window.open('/admin/v2/users/levels?return_after_create=true', '_blank');
            this.allow_refresh = true;
        },
    },

    mounted() {
        this.fetchLevels();
    },
};
